'use client'
import React from 'react'
import { Spinner, Text } from '../../../atoms'
import { GroupedSelectOption, TextTypes } from '../../../../types'

/**
 * react-select calls loadingMessage as a plain function (not <Component />).
 * React Compiler must be disabled here; otherwise it injects memo-cache hooks that
 * throw "Invalid hook call" when react-select invokes this during input change.
 */
export const LoadingComponent = () => {
    'use no memo'

    return (
        <div className="flex justify-center">
            <Spinner />
        </div>
    )
}

export const formatGroupLabel = (group: GroupedSelectOption) => {
    return (
        <div className="border-b border-shade-200 pb-1 -mx-3">
            <Text type={TextTypes.SMALL_TEXT} className="normal-case text-xs px-3">
                {group.label}
            </Text>
        </div>
    )
}
